import Swal from 'sweetalert2';

/**
 * Pre-configured SweetAlert2 instance that matches the Bootstrap UI.
 * Use `AppSwal.fire(...)` instead of `Swal.fire(...)` everywhere.
 */
const AppSwal = Swal.mixin({
  buttonsStyling: false,
  customClass: {
    popup: 'shadow border-0 rounded-3',
    confirmButton: 'btn btn-danger btn-sm ms-2',
    cancelButton: 'btn btn-light btn-sm',
    actions: 'gap-2',
  },
});

export default AppSwal;
